import {
    DELETE_PROPERTY,
    DELETE_PROPERTY_FAILURE,
    DELETE_PROPERTY_SUCCESS,
} from 'store/actions/types';

// Delete Property
export const deleteProperty = (payload) => {
    return {
        type: DELETE_PROPERTY,
        payload: payload,
    };
};

export const deletePropertyFailure = (error) => {
    return {
        type: DELETE_PROPERTY_FAILURE,
        error: error,
    };
};

export const deletePropertySuccess = (payload, response) => {
    return {
        type: DELETE_PROPERTY_SUCCESS,
        payload: payload,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/properties/deleteProperties.js